'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _DefaultString = require('../../helpers/DefaultString');

var _ClientError = require('../../helpers/ClientError');

var _PostLoginFlowStrategySelector = require('../../login/strategy/PostLoginFlowStrategySelector');

var _PostLoginFlowStrategySelector2 = _interopRequireDefault(_PostLoginFlowStrategySelector);

var _Product = require('../../helpers/Product');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _Communication = require('./Communication.scss');

var _Communication2 = _interopRequireDefault(_Communication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Communication = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo, auth: state.auth, log: state.log };
}, { marketingCommunicationPreferences: _auth.marketingCommunicationPreferences, linkIdentityToAccount: _auth.linkIdentityToAccount, linkSecureToken: _auth.linkSecureToken, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Communication, _Component);

  function Communication() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Communication);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Communication.__proto__ || (0, _getPrototypeOf2.default)(Communication)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loadingYes: false,
      loadingNo: false
    }, _this.getMessageText = function () {
      var _this$props$auth = _this.props.auth,
          productName = _this$props$auth.productName,
          clientId = _this$props$auth.clientId;

      return (0, _Product.isKaraokeTsm)(productName, clientId) ? _DefaultString.translations.CommunicationMessageKaraokeTsm : _DefaultString.translations.CommunicationMessage;
    }, _this.getAcceptText = function () {
      var _this$props$auth2 = _this.props.auth,
          productName = _this$props$auth2.productName,
          clientId = _this$props$auth2.clientId;

      return (0, _Product.isKaraokeTsm)(productName, clientId) ? _DefaultString.translations.YesIWantIn : _DefaultString.translations.YesIAccept;
    }, _this.getDeclineText = function () {
      var _this$props$auth3 = _this.props.auth,
          productName = _this$props$auth3.productName,
          clientId = _this$props$auth3.clientId;

      return (0, _Product.isKaraokeTsm)(productName, clientId) ? _DefaultString.translations.IDontLikeDeals : _DefaultString.translations.NoThanks;
    }, _this.onContactUs = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.ContactUs));
    }, _this.submitCommunication = function (response) {
      _this.setState(response ? { loadingYes: true } : { loadingNo: true });
      _this.props.marketingCommunicationPreferences(response);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Communication, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.sendingCommunicationPref && !nextProps.auth.sendingCommunicationPref) {
        if (!nextProps.auth.error) {
          var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(nextProps.auth, this.props.appInfo, this.props.pushState, this.props.log);
          loginStrategy.handleUserInfoResponse(this.props.linkIdentityToAccount, this.props.linkSecureToken, this.props.linkSSOToken);
        } else {
          (0, _ClientError.logClientErrorWithLoggingService)(nextProps.auth.error, new Error().stack, 'universal-componentError', this.props.auth);
          this.props.pushState((0, _Router.getErrorRetryPath)());
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formatMessage = this.props.intl.formatMessage;

      var privacyLink = formatMessage(_DefaultString.translations.PrivacyPolicyLink, { link: (0, _Product.getPrivacyString)(formatMessage, this.props.auth.productName, this.props.appInfo.excludeHeader) });
      var termsLink = formatMessage(_DefaultString.translations.TermsConditionsLink, { link: (0, _Product.getTermsString)(formatMessage, this.props.auth.productName, this.props.appInfo.excludeHeader) });
      var disclamerHTML = formatMessage(_DefaultString.translations.CommunicationDisclaimer, { privacyLink: privacyLink, termsLink: termsLink });
      var messageText = this.getMessageText();
      var acceptText = this.getAcceptText();
      var declineText = this.getDeclineText();

      return _react2.default.createElement(
        'div',
        { className: _Communication2.default.communication },
        _react2.default.createElement(
          'div',
          { className: _Communication2.default.communicationContent },
          _react2.default.createElement(
            'div',
            { className: _Communication2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.CommunicationTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: _Communication2.default.message },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, messageText, {
              values: {
                product: formatMessage((0, _Product.getProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId))
              }
            }))
          ),
          _react2.default.createElement(
            'div',
            { className: _Communication2.default.ctaContainer },
            _react2.default.createElement(_components.BaseButton, {
              className: _Communication2.default.submitYes,
              onClick: function onClick() {
                return _this2.submitCommunication(true);
              },
              buttonString: acceptText,
              loading: this.state.loadingYes
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.BaseButton, {
              className: _Communication2.default.submitNo,
              theme: _BaseButton.ButtonTheme.Outline,
              onClick: function onClick() {
                return _this2.submitCommunication(false);
              },
              buttonString: declineText,
              loading: this.state.loadingNo
            })
          ),
          _react2.default.createElement('div', {
            className: _Communication2.default.disclaimer,
            dangerouslySetInnerHTML: { __html: disclamerHTML }
          }),
          _react2.default.createElement(_components.BaseButton, {
            className: _Communication2.default.contactUs,
            onClick: this.onContactUs,
            theme: _BaseButton.ButtonTheme.Secondary,
            buttonString: _DefaultString.translations.ContactUsTextOnly
          })
        )
      );
    }
  }]);
  return Communication;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  linkIdentityToAccount: _react.PropTypes.func,
  linkSecureToken: _react.PropTypes.func,
  linkSSOToken: _react.PropTypes.func,
  log: _react.PropTypes.object,
  marketingCommunicationPreferences: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(Communication);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Communication/Communication.js
// module id = 2000
// module chunks = 0